import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

import Api from '../../../libraries/api';
import Storage from '../../../libraries/storage';
import { history } from '../../../shared/configure-store';
import { toDisplayOrder } from '../master-case-survey-status/order-display';

const API_BASE = '/lifecycle/approval-status-master';
const ROUTE_BASE = '/master-approval-status';

class MasterApprovalStatus extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            searchBy: '',
            orderBy: 'sort_order',
            sortedBy: 'asc',
            showDialog: false,
            idDelete: '',
            currDelete: '',
            rows: [],
            allRows: [],
            isUpdate: false,
            isDelete: false,
            isCreate: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Approval Status';
        this.__fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    normalizeList(resp) {
        const raw = resp?.data;
        if (Array.isArray(raw)) return raw;
        if (Array.isArray(raw?.data)) return raw.data;
        return [];
    }

    applyFiltersAndSort = () => {
        const { allRows, searchBy, orderBy, sortedBy } = this.state;
        let rows = [...allRows];

        if (searchBy) {
            const q = searchBy.trim().toLowerCase();
            rows = rows.filter((row) => String(row?.name || '').toLowerCase().includes(q));
        }

        if (orderBy) {
            rows.sort((a, b) => {
                let left = a?.[orderBy];
                let right = b?.[orderBy];

                if (orderBy === 'sort_order') {
                    left = Number(left ?? 0);
                    right = Number(right ?? 0);
                } else {
                    left = String(left || '').toLowerCase();
                    right = String(right || '').toLowerCase();
                }

                if (left < right) return sortedBy === 'asc' ? -1 : 1;
                if (left > right) return sortedBy === 'asc' ? 1 : -1;
                return 0;
            });
        }

        return rows;
    };

    __fetchData = () => {
        this._isMounted = true;
        this.setState({ loading: true });

        Api.get(API_BASE)
            .then((resp) => {
                if (!this._isMounted) return;

                const allRows = this.normalizeList(resp);
                const custom = resp?.meta?.custom || {};

                this.setState(
                    {
                        allRows,
                        loading: false,
                        isUpdate: custom.isUpdate ?? custom.isEdit ?? false,
                        isDelete: custom.isDelete ?? false,
                        isCreate: custom.isCreate ?? false,
                    },
                    () => {
                        this.setState({ rows: this.applyFiltersAndSort() });
                    }
                );
            })
            .catch(() => {
                if (this._isMounted) {
                    this.setState({ loading: false, rows: [], allRows: [] });
                }
            });
    };

    handleSearch = () => {
        this.setState({ rows: this.applyFiltersAndSort() });
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') this.handleSearch();
    };

    handleSort = (val) => {
        let sortedBy = this.state.sortedBy;

        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            sortedBy = sortedBy === 'asc' ? 'desc' : 'asc';
        }

        this.setState({ orderBy: val, sortedBy }, () => {
            this.setState({ rows: this.applyFiltersAndSort() });
        });
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.id,
            currDelete: row.name,
        });
    };

    handleClose = () => {
        this.setState({ showDialog: false });
    };

    handleDelete = () => {
        if (!this.state.idDelete) return;

        this.setState({ loadingButton: true });

        const host = process.env.REACT_APP_API_SERVER_URL;
        let access_token = Storage.get('access_token');
        if (access_token) {
            access_token = access_token.replace(/['"]+/g, '');
        }

        fetch(`${host}${API_BASE}/${this.state.idDelete}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...(access_token ? { Authorization: `Bearer ${access_token}` } : {}),
            },
        })
            .then((resp) => {
                if (!resp.ok) {
                    return Promise.reject();
                }
                this.setState({ showDialog: false, loadingButton: false });
                this.showMessage(true, 'Approval status successfully deleted');
                this.__fetchData();
            })
            .catch(() => {
                this.setState({ showDialog: false, loadingButton: false });
                this.showMessage(false, 'Failed to delete approval status');
            });
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleGo = (link) => {
        history.push(link);
    };

    getNextDisplayOrder() {
        const { allRows } = this.state;
        if (!allRows.length) return 1;

        const maxBackend = allRows.reduce((max, row) => {
            const n = Number(row.sort_order);
            return Number.isFinite(n) ? Math.max(max, n) : max;
        }, -1);

        return toDisplayOrder(maxBackend) + 1;
    }

    renderSortIcon(field) {
        if (this.state.orderBy !== field) return null;
        return (
            <span className="icon-sort">
                {this.state.sortedBy === 'asc' ? (
                    <i className="fas fa-sort-up"> </i>
                ) : (
                    <i className="fas fa-sort-down"> </i>
                )}
            </span>
        );
    }

    render() {
        const { loading, rows, isCreate, isUpdate, isDelete } = this.state;

        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Approval Status</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Approval Status
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <div className="row align-items-center mb-md-3">
                            <div className="col-md-6">
                                <TextField
                                    id="approval-status-search"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton aria-label="Search" onClick={this.handleSearch}>
                                                    <i className="fas fa-search"> </i>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="col-md-6 text-md-right">
                                {isCreate ? (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className="mb-3 mb-md-0"
                                        onClick={() =>
                                            this.handleGo(`${ROUTE_BASE}/add?no=${this.getNextDisplayOrder()}`)
                                        }
                                    >
                                        Add New Status
                                    </Button>
                                ) : null}
                            </div>
                        </div>

                        <Table className="table-list" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        className="clickable"
                                        onClick={() => this.handleSort('sort_order')}
                                    >
                                        No.
                                        {this.renderSortIcon('sort_order')}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('name')}>
                                        Name
                                        {this.renderSortIcon('name')}
                                    </TableCell>
                                    {isUpdate || isDelete ? <TableCell>Action</TableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={isUpdate || isDelete ? 3 : 2} align="center" className="py-5">
                                            <CircularProgress color="primary" />
                                        </TableCell>
                                    </TableRow>
                                ) : rows.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={isUpdate || isDelete ? 3 : 2}
                                            style={{ textAlign: 'center' }}
                                        >
                                            No approval status data
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    rows.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell>{toDisplayOrder(row.sort_order)}</TableCell>
                                            <TableCell>{row.name ?? 'NA'}</TableCell>
                                            {isUpdate || isDelete ? (
                                                <TableCell>
                                                    <div className="d-flex justify-content-center">
                                                        {isUpdate ? (
                                                            <Link
                                                                to={`${ROUTE_BASE}/edit/${row.id}`}
                                                                className="btn-icon mr-2"
                                                            >
                                                                <i className="fas fa-edit"> </i>
                                                            </Link>
                                                        ) : null}
                                                        {/* {isDelete ? (
                                                            <button
                                                                type="button"
                                                                className="btn-icon"
                                                                onClick={() => this.handleOpen(row)}
                                                            >
                                                                <i className="fas fa-trash-alt"> </i>
                                                            </button>
                                                        ) : null} */}
                                                    </div>
                                                </TableCell>
                                            ) : null}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <Dialog
                    maxWidth="sm"
                    fullWidth
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">DELETE DATA: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you want to delete this approval status?</p>
                    </DialogContent>
                    <DialogActions>
                        <Button className="mr-3" variant="contained" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled'}
                        >
                            Delete
                            {this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>}
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer autoClose={3000} />
            </div>
        );
    }
}

export default MasterApprovalStatus;
